import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HisBackendService } from 'hisng';
import { PersonProfile } from '../model/personprofile';

@Injectable()
export class PersonProfileEntryService {
    constructor(private backendService: HisBackendService) {}

    getPersonProfileForPerson( personId: number ): Observable<PersonProfile> {
        return this.backendService.getData( `api/v1/cs/psv/personProfile/entries/${personId}` );
    }

    savePersonProfile( personId: number, personProfile: PersonProfile ): Observable<PersonProfile> {
        return this.backendService.postData( `api/v1/cs/psv/personProfile/entries/update/${personId}`, personProfile );
    }

    canEditProfile( personId: number ): Observable<boolean> {
        return this.backendService.postData(
            `api/v1/fs/res/hasRightsOnObject/Person/${personId}/true`,
            ['RIGHT_CS_PSV_PROFILE_EDIT_PROFILE', 'RIGHT_CS_PSV_PROFILE_EDIT_PROFILE_OWN']
        );
    }
}
